import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { useEffect } from 'react';
import { z } from 'zod';
import { useUpdateAdminPlanMutation } from '../hooks/useUpdateAdminPlanMutation';

const updatePlanSchema = z.object({
  planName: z.string().min(1, { message: 'common.form.validation.required' }),
  planNameEnglish: z.string().min(1, { message: 'common.form.validation.required' }),
  noOfPeople: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  lastEntryTime: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
});

type DefaultValues = {
  planName: string;
  planNameEnglish: string;
  noOfPeople: string;
  lastEntryTime: string;
};

const noOfPeopleOption = [
  {
    value: '1',
    label: '1名',
  },
  {
    value: '2',
    label: '2名',
  },
  {
    value: '3',
    label: '3名',
  },
  {
    value: '4',
    label: '4名',
  },
  {
    value: '5',
    label: '5名',
  },
  {
    value: '6',
    label: '6名',
  },
  {
    value: '7',
    label: '7名',
  },
  {
    value: '8',
    label: '8名',
  },
  {
    value: '9',
    label: '9名',
  },
  {
    value: '10',
    label: '10名',
  },
];

const AdminPlanFormView = ({
  clubId,
  planId = '',
  defaultValues,
  lastEntryTimeOptions,
}: {
  clubId: string;
  planId?: string;
  defaultValues: DefaultValues;
  lastEntryTimeOptions: { label: string; value: string }[];
}) => {
  const form = useForm({
    schema: updatePlanSchema,
    mode: 'onBlur',
    defaultValues,
  });

  useEffect(() => {
    form.reset(defaultValues);
  }, [defaultValues, form]);

  const { mutateAsync } = useUpdateAdminPlanMutation();
  return (
    <Form
      form={form}
      onSubmit={async (formValues) => {
        await mutateAsync({
          clubId,
          planId,
          lastEntryTime: formValues.lastEntryTime,
          noOfPeople: Number(formValues.noOfPeople),
        });
      }}
    >
      <fieldset disabled={!defaultValues}>
        <div className="grid grid-cols-2 gap-4.5">
          <Input label="common.form.label.planTitle" {...form.register('planNameEnglish')} disabled />
          <Input
            {...form.register('planName')}
            label="configurationManagement.plans.page.managePlansModal.planTitleJp"
            disabled
          />

          <Select
            options={lastEntryTimeOptions}
            {...form.register('lastEntryTime')}
            placeholder="HH:MM"
            label="common.form.label.lastEntryTime"
          />

          <Select
            options={noOfPeopleOption}
            {...form.register('noOfPeople')}
            label="common.form.label.numberOfPeople"
          />
        </div>
      </fieldset>
    </Form>
  );
};

export default AdminPlanFormView;
